export default "__VITE_ASSET__C495TayX__"